import moment from 'moment-timezone'
import { settings } from '@/utils/settings'
import store from '@/store'
import { formatUtcDateTime } from '@/utils/timezone'

const getTenantLocale = () =>
  store.getters['tenant/tenantLocale'] || settings.LOCALE || 'en-AU'
const getTenantCurrency = () =>
  store.getters['tenant/tenantCurrency'] || settings.CURRENCY || 'AUD'

export const filters = {
  currency(value, notAvailable = '-', scale = 2, maxScale = scale) {
    return (
      (typeof value === 'number' &&
        value.toLocaleString(getTenantLocale(), {
          style: 'currency',
          currency: getTenantCurrency(),
          minimumFractionDigits: scale,
          maximumFractionDigits: maxScale
        })) ||
      notAvailable
    )
  },

  formatDate(value, format = 'DD/MM/YYYY', notAvailableDisplay = '-') {
    return (value && moment(value).format(format)) || notAvailableDisplay
  },

  formatDatePicker(value, format = 'DD/MM/YYYY') {
    return value && moment(value).format(format)
  },

  formatDateTime12h(value, notAvailableDisplay = '-') {
    return formatUtcDateTime(value, 'DD/MM/YYYY h:mm a', notAvailableDisplay)
  },

  text(value, notAvailable = '-') {
    return value || notAvailable
  },

  percentage(value, notAvailable = '-') {
    return `${value?.toFixed(2)} %` || notAvailable
  },

  sentenceCase(value, notAvailable = '-') {
    return (
      value
        ?.split(' ')
        .map((l) => l[0].toUpperCase() + l.substr(1).toLowerCase())
        .join(' ') || notAvailable
    )
  }
}

export function installFilters(app) {
  if (app.config?.globalProperties) {
    app.config.globalProperties.$filters = filters
  } else if (app.prototype) {
    app.prototype.$filters = filters
  }

  app.mixin({
    filters
  })
}

export default {
  install: installFilters
}
